(function () {
  const ICON_SELECTOR = '.product-metafield-icons--pdp';
  const HIDDEN_CLASS = 'is-hidden-by-slide';

  function initGallery(gallery) {
    const carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    const icons = gallery.querySelectorAll(ICON_SELECTOR);
    if (!icons.length) return;

    carousel.addEventListener('carousel:change', function (event) {
      const isFirst = event.detail.index === 0;
      icons.forEach(function (icon) {
        icon.classList.toggle(HIDDEN_CLASS, !isFirst);
      });
    });
  }

  function init() {
    document.querySelectorAll('product-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
